import updateProfile from 'services/api/profile/updateProfile';
import constants from 'services/api/profile/constants';
import Empty from 'constants/empty';

const { EmailSubscriptionTypes, SubscriptionStatus, PromotionalEmailsPrefsFrequency } = constants;

function setCommunicationPreferences(prefs) {
    const subscriptionPreferredCountry = prefs?.subscriptionPreferredCountry || Empty.String;
    const subscriptionPreferredLanguage = prefs?.subscriptionPreferredLanguage || Empty.String;
    const subscriptionPreferredZipCode = prefs?.subscriptionPreferredZipCode || Empty.String;

    let userSelectedLanguage = false;

    let subscriptionsPayload = {
        subscriptions: []
    };

    if (subscriptionPreferredCountry !== '' && subscriptionPreferredLanguage !== '') {
        userSelectedLanguage = true;

        subscriptionsPayload = {
            ...subscriptionsPayload,
            subscriptionPreferredCountry,
            subscriptionPreferredLanguage
        };
    }

    // For each subscription the user has, a subscription object needs to be added.
    if (prefs?.notificationsAndReminders?.subscribed) {
        let subscriptionInformation = {
            subscriptionFrequency: PromotionalEmailsPrefsFrequency.DAILY,
            subscriptionStatus: SubscriptionStatus.SUBSCRIBED,
            subscriptionType: EmailSubscriptionTypes.TRIGGERED
        };

        if (userSelectedLanguage) {
            subscriptionInformation = {
                ...subscriptionInformation,
                subscriptionRegion: subscriptionPreferredCountry,
                subscriptionZip: subscriptionPreferredZipCode,
                countryLocation: subscriptionPreferredCountry,
                subscriptionLanguage: subscriptionPreferredLanguage
            };
        }

        subscriptionsPayload.subscriptions.push(subscriptionInformation);
    }

    if (prefs?.promotionalEmail?.subscribed) {
        let subscriptionInformation = {
            subscriptionFrequency: prefs?.promotionalEmail?.frequency || PromotionalEmailsPrefsFrequency.DAILY,
            subscriptionStatus: SubscriptionStatus.SUBSCRIBED,
            subscriptionType: EmailSubscriptionTypes.CONSUMER
        };

        if (userSelectedLanguage) {
            subscriptionInformation = {
                ...subscriptionInformation,
                subscriptionRegion: subscriptionPreferredCountry,
                subscriptionZip: subscriptionPreferredZipCode,
                countryLocation: subscriptionPreferredCountry,
                subscriptionLanguage: subscriptionPreferredLanguage
            };
        }

        subscriptionsPayload.subscriptions.push(subscriptionInformation);
    }

    if (prefs?.postalMail?.subscribed) {
        let subscriptionInformation = {
            subscriptionFrequency: prefs?.postalMail?.frequency || PromotionalEmailsPrefsFrequency.ANNUAL,
            subscriptionStatus: SubscriptionStatus.SUBSCRIBED,
            subscriptionType: EmailSubscriptionTypes.MAIL
        };

        if (userSelectedLanguage) {
            subscriptionInformation = {
                ...subscriptionInformation,
                subscriptionRegion: subscriptionPreferredCountry,
                subscriptionZip: subscriptionPreferredZipCode,
                countryLocation: subscriptionPreferredCountry,
                subscriptionLanguage: subscriptionPreferredLanguage
            };
        }

        subscriptionsPayload.subscriptions.push(subscriptionInformation);
    }

    return updateProfile(subscriptionsPayload);
}

export default {
    setCommunicationPreferences
};
